"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHyperviewEntityData = void 0;
var react_1 = require("react");
var WidgetContext_1 = require("./WidgetContext");
function useHyperviewEntityData() {
    var context = (0, react_1.useContext)(WidgetContext_1.WidgetContext);
    if (context === null) {
        throw new Error("useHyperviewEntityData must be used within a WidgetProvider");
    }
    var hyperviewContext = context.widget.context.hyperviewContext;
    if (hyperviewContext) {
        return {
            organisation: { id: hyperviewContext.organisation.id },
            entity: {
                name: hyperviewContext.entity.name,
                displayName: hyperviewContext.entity.displayName,
                colour: hyperviewContext.entity.colour
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            keys: hyperviewContext.keys,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            properties: hyperviewContext.properties,
            toUri: function () { return hyperviewContext.toUri(); }
        };
    }
    else {
        return undefined;
    }
}
exports.useHyperviewEntityData = useHyperviewEntityData;
